module.exports = __webpack_public_path__ + "assets/zjmp_icon5.9b348bff.svg";